import { Pipe, PipeTransform } from '@angular/core';
import { ScoreService } from '../score.service';

@Pipe({
  name: 'scoreBase',
  standalone: false,
})
export class ScoreBasePipe implements PipeTransform {
  constructor(private scoreService: ScoreService) {}

  transform(value: any, isThirdParty: boolean = false, customBase: number = null): any {
    return this.scoreService.getScaledScore(value, isThirdParty, customBase);
  }
}
